module.exports = __webpack_public_path__ + "img/求职招聘.85182083.png";